/**
 * Remove keys with `undefined` or `null` values from the provided object (e.g. a set of query params)
 *
 * @param {Object} obj
 * @returns {Object}
 */
export default function removeEmptyKeys(obj) {
  return Object.keys(obj)
    .filter(k => obj[k] !== null && obj[k] !== undefined) // filter out keys with null/undefined values
    .reduce(
      (newObj, k) =>
        typeof obj[k] === 'object'
          ? { ...newObj, [k]: removeEmptyKeys(obj[k]) } // recurse
          : { ...newObj, [k]: obj[k] }, // base case: clean object
      {}
    ); // rebuild an object using the filtered keys
}
